import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import { UiComponents } from "@simulanisindia/ui";
import BtnLoad from "../common/BtnLoad";
import { AddProjectLightIcon } from "../../Assest/icons/icons";

const { SimInputBar, DropdownSearch } = UiComponents;

const EditTask = ({ showEditTask, handleCloseEditTask, saveEditTask, editValue, scenarioList }) => {
    const [error, setError] = useState(false);
    const [task, setTask] = useState({})

    let options = scenarioList.map(item => ({
        value: item.id,
        label: item.name
    }));;

    const handleChangeTaskValue = (e) => {
        const name = e.target.name;
        const value = e.target.name == "isCritical" ? e.target.checked : e.target.value
        setTask({
            ...task,
            [name]: e.target.name == "isCritical" ? value : value.startsWith("0") ? value.slice(1) : value
        });
    }

    const handleScenarioChange = (selectedOption) => {
        setTask({
            ...task,
            scenario: selectedOption.value
        });
    };

    const handleSave = () => {
        if (task.title && task.plannedTime && task.priority && task.taskDesc) {
            saveEditTask(task);
            setTask({});
        } else {
            setError(true);
            setTimeout(() => { setError(false) }, 2500);
        }
    }

    useEffect(() => {
        setTask({ ...editValue })
    }, [editValue])

    return (
        <>
            <Modal show={showEditTask} centered onHide={handleCloseEditTask} className="createModal">
                <div className="customModalHead">
                    <div className="filterbtn">
                        <div className="btninadjust">
                            <AddProjectLightIcon />
                        </div>
                    </div>
                    <h6> Edit Task</h6>
                </div>
                <Modal.Body>
                    <div className="projectCreation">
                        <div className="inputItem ">
                            <p>Title</p>
                            <SimInputBar
                                placeholder="Enter task title"
                                name="title"
                                value={task.title}
                                onChange={handleChangeTaskValue}
                            />
                        </div>

                        <div className="inputItem mt-3">
                            <p>Time</p>
                            <SimInputBar
                                type="number"
                                name="plannedTime"
                                placeholder="Enter time in minutes"
                                value={task.plannedTime}
                                onChange={handleChangeTaskValue}
                            />
                        </div>

                        <div className="inputItem mt-3">
                            <p>Priority</p>
                            <SimInputBar
                                type="number"
                                name="priority"
                                placeholder="Enter priority level (1-10)"
                                value={task.priority}
                                onChange={handleChangeTaskValue}
                            />
                        </div>

                        {/* <div className="inputItem mt-3">
                            <p>Scenario</p>
                            <DropdownSearch
                                label=""
                                selectProps={{
                                    options: options,
                                    value: options.find(option => option.value === task.scenario),
                                    placeholder: "Select scenario...",
                                    onChange: handleScenarioChange,
                                }}
                            />
                        </div> */}

                        <div className="inputItem mt-3">
                            <p>Description</p>
                            <SimInputBar
                                placeholder="Enter task description"
                                name="taskDesc"
                                value={task.taskDesc}
                                onChange={handleChangeTaskValue}
                                multiline
                                rows={3}
                            />
                        </div>

                        <div className="inputItem mt-3">
                            <div className="checkbox-container">
                                <label className="checkbox-label">
                                    <input
                                        type="checkbox"
                                        name="isCritical"
                                        checked={task.isCritical}
                                        onChange={handleChangeTaskValue}
                                        className="checkbox-input"
                                    />
                                    <span className="checkbox-text">Critical</span>
                                </label>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <div className="modalFooterB">
                    <button className="cancel" onClick={handleCloseEditTask}>
                        Cancel
                    </button>
                    <button className="save" onClick={handleSave}>
                        Save
                    </button>
                </div>
            </Modal>
        </>
    );
};

export default EditTask;
